import { UserRole } from '@/types'

export const ROLE_PERMISSIONS: Record<UserRole, string[]> = {
  admin: [
    'dashboard:view',
    'shipments:view',
    'shipments:create',
    'shipments:edit',
    'shipments:delete',
    'inventory:view',
    'inventory:create',
    'inventory:edit',
    'inventory:delete',
    'contracts:view',
    'contracts:create',
    'contracts:edit',
    'contracts:delete',
    'clearing:view',
    'clearing:edit',
    'storage:view',
    'storage:edit',
    'load_out:view',
    'load_out:create',
    'load_out:edit',
    'vendors:view',
    'vendors:create',
    'vendors:edit',
    'vendors:delete',
    'payments:view',
    'payments:create',
    'payments:edit',
    'reports:view',
    'reports:export',
    'documents:view',
    'documents:upload',
    'documents:delete',
    'users:view',
    'users:create',
    'users:edit',
    'users:delete',
  ],
  operations_manager: [
    'dashboard:view',
    'shipments:view',
    'shipments:create',
    'shipments:edit',
    'contracts:view',
    'contracts:create',
    'contracts:edit',
    'contracts:delete',
    'clearing:view',
    'clearing:edit',
    'storage:view',
    'load_out:view',
    'load_out:create',
    'load_out:edit',
    'vendors:view',
    'reports:view',
    'reports:export',
    'documents:view',
    'documents:upload',
    'documents:delete',
  ],
  inventory_manager: [
    'dashboard:view',
    'inventory:view',
    'inventory:create',
    'inventory:edit',
    'storage:view',
    'storage:edit',
    'load_out:view',
    'reports:view',
    'documents:view',
    'documents:upload',
  ],
  clearing_officer: [
    'dashboard:view',
    'shipments:view',
    'clearing:view',
    'clearing:edit',
    'documents:view',
    'documents:upload',
  ],
  finance_team: [
    'dashboard:view',
    'shipments:view',
    'load_out:view',
    'vendors:view',
    'payments:view',
    'payments:create',
    'payments:edit',
    'reports:view',
    'reports:export',
    'documents:view',
    'documents:upload',
  ],
}

export const hasPermission = (userRole: UserRole, permission: string): boolean => {
  return ROLE_PERMISSIONS[userRole]?.includes(permission) ?? false
}

/** Finance uploads sales invoices only; ops roles upload all dispatch document types. */
export const canUploadStockDispatchDocument = (
  userRole: UserRole,
  docType: string
): boolean => {
  if (!hasPermission(userRole, 'documents:upload')) return false
  if (userRole === 'finance_team') return docType === 'salesInvoice'
  return true
}

